import React, {Component} from 'react';
import {Col, Row, TabContent, TabPane} from "reactstrap";
import home from "../../../../util/clipstore/user/home";
import ViewerProfileHeader from "../../../../components/clipstore/user/profile/header";
import constants from "../../../../util/constants";
import {connect} from "react-redux";
import * as actions from "../../../../actions";
import api from "../../../../util/user/api";
import profile_util from "../../../../util/clipstore/broadcaster/profile";
import FollowingContainer from "../../../user/following";
import util from "../../../../util/messaging/utility";
import sb from "../../../../util/sendbird";
import sb_util from "../../../../util/sb/util";
import {isEmpty, vuepayAlert} from "../../../../util/utility";
import {getData, USER_DATA} from "../../../../util/storage";

class ViewerProfileForOthers extends Component {


    constructor(props) {
        super(props);
        this.state = {
            viewerActiveTab: 'following',
            userID: -1,
            userData: null,
            currentUserData: null,
            sortBy: "popularity",
            query: '',
            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
            reset: false,
            hasMore: true,

            clickedOnIndex: -1,
            content: {},
            followingList: [],
            isFetching: false,
            isFavClicked:false
        }
    }

    componentDidMount() {
        this.init();

        profile_util.getUserData((data) => {
            this.setState({currentUserData: data});
        })
    }

    getBroadcasterID = (callback) => {
        getData(USER_DATA)
            .then((data) => {
                if (!isEmpty(data)) {
                    let broadcasterTypeObj = data.hasOwnProperty("broadcaster") &&
                        data.broadcaster &&
                        Array.isArray(data.broadcaster) &&
                        data.broadcaster.length > 0 &&
                        data.broadcaster[0];
                    callback(broadcasterTypeObj)
                } else {
                    callback(null)
                }
            });
    }

    componentDidUpdate(prevProps) {

        if (this.props.history.action !== "POP") {
            const isChanges = this.props.location.pathname !== prevProps.location.pathname;
            if (isChanges) {
                this.setState({
                    viewerActiveTab: 'following',
                    userID: -1,
                    userData: null,
                    sortBy: "popularity",
                    query: '',
                    currentPage: 1,
                    totalPages: 1,
                    currentItems: 12,
                    totalItems: 12,
                    reset: false,
                    hasMore: true,
                    content: {},
                    followingList: [],
                }, () => {
                    this.init();
                });
            }
        } else if (this.props.history.action === "POP") {
            //this.props.history.push(`/dashboard`);
        }
    }

    initiateSendBird = (from, to, toItem) => {
        sb_util.sendBirdLogin("broadcaster",
            () => {
                util.getChatIds(from, to, toItem, (chatIdsArray) => {
                    sb.sbCreateChannel(chatIdsArray,
                        (groupChannel) => {
                            console.log("ViewerProfileForOthers >> successCallback", JSON.stringify(groupChannel));

                            let member = groupChannel.members;
                            if (member.length === 2) {
                                this.props.history.push({
                                    pathname: `/${to}/messaging`,
                                    state: {
                                        selectedChannel: groupChannel,
                                    }
                                });
                            } else {
                                vuepayAlert("error", "Sorry, there was a connection issue, please report it to support.")
                            }

                        }, (error) => {
                            console.log("ViewerProfileForOthers >> errorCallback", error)
                        })
                })
            }, () => {

            })
    }

    clickedOnChat = (broadcaster_id) => {
        console.log("clickedOnChat", broadcaster_id);
        let from = "broadcaster";
        let to = "broadcaster";
        let toItem = {
            user_id: "",
            broadcaster_id: broadcaster_id
        }
        this.initiateSendBird(from, to, toItem)
    }

    startNewChat = (user_id) => {
        console.log("startNewChat", user_id);
        let from = "broadcaster";
        let to = "user";
        let toItem = {
            user_id: user_id,
            broadcaster_id: ""
        }
        this.initiateSendBird(from, to, toItem)
    }

    favUser = () => {

        this.setState({
            isFetching: true,
            isFavClicked:true,
        }, () => {
            const user_id = this.state.userData.user_id;
            const is_favourite = this.state.userData.summary.is_favourite;
            this.getBroadcasterID((broadcaster) => {
                api.clickedOnFavUnFavAPI(this.props, is_favourite, user_id, broadcaster.id, () => {
                    this.setState({
                        isFetching: false,
                        isFavClicked:false
                    })
                });
            })
        })
    }

    clickedOnFollowUnfollow = (index) => {

        this.setState({
            clickedOnIndex: index,
            content: this.state.followingList[index]
        }, () => {
            const is_following = this.state.content.is_following;
            const broadcaster_id = this.state.content.id;
            api.clickedOnFollowUnfollowAPI(this.props, is_following, broadcaster_id);
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if ((nextProps.availability.favoriteUserSuccess || nextProps.availability.unFavoriteUserSuccess) && this.state.isFavClicked) {
            let userData = this.state.userData;
            if(userData !==null){
                userData.summary.is_favourite = !userData.summary.is_favourite;
                this.setState({
                    userData,
                    isFetching: false,
                    isFavClicked:false
                },()=>{
                    api.getFavList(this.props);
                })
            }
        } else if (nextProps.availability.favoriteUserError || nextProps.availability.unFavoriteUserError) {
            this.setState({
                isFetching: false,
                isFavClicked:false
            })
        }


        //this will be called for every pagination we perform
        if (nextProps.user_following_other && nextProps.user_following_other.payload !== this.props.user_following_other.payload) {

            console.log("user_following_other", nextProps.user_following_other.payload);

            if (nextProps.user_following_other.payload &&
                nextProps.user_following_other.payload.hasOwnProperty("data") &&
                nextProps.user_following_other.payload.data.hasOwnProperty("data")) {


                let data = nextProps.user_following_other.payload.data;
                let followingList = data.data;

                if (this.state.currentPage !== 1) {
                    if (followingList.length > 0) {
                        followingList = this.state.followingList.concat(followingList)
                    } else {
                        followingList = this.state.followingList;
                    }
                }

                this.setState({
                    currentPage: parseInt(data.current_page),
                    hasMore: parseInt(data.current_page) <= parseInt(data.last_page),
                    totalPages: parseInt(data.last_page),
                    currentItems: parseInt(data.current_page) * followingList.length,
                    totalItems: parseInt(data.total),
                    followingList,
                    reset: false
                }, () => {
                    if (this.state.hasMore && this.state.currentPage < 3) {
                        this.loadNextPage();
                    }
                })
            }

            this.props.resetGetFollowingListById();

        }

        if (nextProps.user_profile_other && nextProps.user_profile_other.payload !== this.props.user_profile_other.payload) {
            console.log("user_profile_other", nextProps.user_profile_other.payload);
            if (nextProps.user_profile_other.payload &&
                nextProps.user_profile_other.payload.hasOwnProperty("data")) {

                this.setState({
                    userData: nextProps.user_profile_other.payload.data
                })
            }
            this.props.resetGetUserDetailsById();
        }

        if (nextProps.following &&
            nextProps.following.follow_unfollow_data != null &&
            nextProps.following.follow_unfollow_data.hasOwnProperty("success") &&
            !nextProps.following.isFetching &&
            nextProps.following.isSuccess
        ) {
            this.props.resetFollowUnFollowData();

            let followingList = this.state.followingList;
            let followers_count = this.state.content.followers_count;
            let is_following = this.state.content.is_following;
            followingList[this.state.clickedOnIndex] = {
                ...this.state.content,
                followers_count: is_following ? (followers_count - 1) : (followers_count + 1),
                is_following: !is_following
            }
            this.setState({
                followingList
            })
        }
    }

    init = () => {
        console.log("ViewerProfileForOthers >> init")
        const userID = profile_util.getUserId(this.props)

        if (userID !== -1) {
            this.setState({
                userID,
            }, () => {
                api.getUserDetailsByIdAPI(this.props, `${this.state.userID}`)
                api.getFollowingListByIdAPI(this.props, `${this.state.userID}`, this.state.currentPage, this.state.query, this.state.sortBy)
            });
        } else {
            //move the user out from here
        }
    }

    toggleViewerTabs = (tab) => {
        if (this.state.viewerActiveTab !== tab) {
            this.setState({
                viewerActiveTab: tab,
            });
        }
    };

    resetFollowing = () => {
        this.setState({
            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
            reset: false,
            hasMore: true,
            content: {},
            followingList: [],
        }, () => {
            api.getFollowingListByIdAPI(this.props, `${this.state.userID}`, this.state.currentPage, this.state.query, this.state.sortBy)
        });
    }

    loadNextPage = () => {
        let currentPage = this.state.currentPage;
        currentPage = currentPage + 1;

        this.setState({
            currentPage
        }, () => {
            api.getFollowingListByIdAPI(this.props, `${this.state.userID}`, this.state.currentPage, this.state.query, this.state.sortBy)
        })
    }

    setSortBy = (sortBy) => {
        this.setState({
            sortBy
        }, () => {
            this.resetFollowing();
        })
    }

    searchInFollowingList = (query) => {
        this.setState({
            query
        }, () => {
            this.resetFollowing();
        })
    }

    render() {
        return (
            <main role="main" className="container-fluid">
                <Row className={"broadcast-container-parent"} id="homeContainerScrollableDiv">
                    <Col md="12" className="home-container">
                        <ViewerProfileHeader
                            {...this.props}
                            isForOther={true}
                            userData={this.state.userData}
                            isLoggedIn={true}
                            pageName={constants.VIEWER_PROFILE}
                            contentList={[]}
                            activeTab={this.state.viewerActiveTab}
                            payload={null}
                            toggle={this.toggleViewerTabs}
                            showLogin={() => {
                                home.showLogin(this.props)
                            }}
                            startNewChat={this.startNewChat}
                            favUser={this.favUser}
                            isFetching={this.state.isFetching}
                        />
                    </Col>
                </Row>

                <Row className="broadcast-container-parent">
                    <Col md="12">
                        <TabContent activeTab={this.state.viewerActiveTab}>
                            <TabPane tabId="following">
                                <FollowingContainer
                                    searchText={this.state.query}
                                    hasMore={this.state.hasMore}
                                    followingList={this.state.followingList}
                                    loadNextPage={this.loadNextPage}
                                    searchInFollowingList={this.searchInFollowingList}
                                    setSortBy={this.setSortBy}
                                    sortBy={this.state.sortBy}
                                    currentUserData={this.state.currentUserData}


                                    following={this.props.following}
                                    clickedOnChat={this.clickedOnChat}
                                    clickedOnFollowUnfollow={this.clickedOnFollowUnfollow}
                                />
                            </TabPane>

                            <TabPane tabId="viewer_about">
                                About
                            </TabPane>

                        </TabContent>
                    </Col>
                </Row>
            </main>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        flag: state.flag,
        device: state.device.payload,
        following: state.following,
        user_profile_other: state.user_profile_other,
        user_following_other: state.user_following_other,
        availability: state.availability,
    };
}

export default connect(mapStateToProps, actions)(ViewerProfileForOthers);


